import React from 'react';
import {Typography} from '@/components/ui/typography';

const PageHeadingSection = (props) => {
    return (
        <div className="flex-col justify-start items-start gap-4 inline-flex">
            <div className="text-sky-950 text-[32px] font-bold leading-10">
                {props.title}
            </div>
            <div className="self-stretch text-sky-950 text-[14px] font-normal leading-normal">
                {props.subtitle}
            </div>
        </div>
    )

    return (
        <div className="flex flex-col justify-center align-center gap-6">
            <Typography variant="h1" className="text-center" asChild>
                <h1>
                    {}
                </h1>
            </Typography>
            <Typography variant="h4" className="text-center">
                {}
            </Typography>
        </div>
    )
};

export default PageHeadingSection;
